import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[DragScroll]'
})
export class DragScrollDirective {

  private element:HTMLElement;
  private isDown:boolean = false;
  private startX:number;
  private startY:number;
  private scrollLeft:number;
  private scrollTop:number;

  constructor(
    private el:ElementRef
  ) {
    this.element = el.nativeElement;
    this.element.addEventListener('touchstart', (e: TouchEvent) => {
      this.isDown = true;
      this.startX = e.touches[0].pageX - this.element.offsetLeft;
      this.startY = e.touches[0].pageY - this.element.offsetTop;
      this.scrollLeft = this.element.scrollLeft;
      this.scrollTop = this.element.scrollTop;
    });
    this.element.addEventListener('touchleave', () => {
      this.isDown = false;
    });
    this.element.addEventListener('touchend', () => {
      this.isDown = false;
    });
    this.element.addEventListener('touchmove', (e) => {
      if(!this.isDown) return;
      e.preventDefault();
      const x = e.touches[0].pageX - this.element.offsetLeft;
      const y = e.touches[0].pageY - this.element.offsetTop;
      const walkX = (x - this.startX);
      const walkY = (y - this.startY);
      this.element.scrollLeft = this.scrollLeft - walkX;
      this.element.scrollTop = this.scrollTop - walkY;
    });
  }

}
